import { render, staticRenderFns } from "./ProductSettings.vue?vue&type=template&id=5062eea6&scoped=true"
import script from "./ProductSettings.vue?vue&type=script&lang=js"
export * from "./ProductSettings.vue?vue&type=script&lang=js"
import style0 from "./ProductSettings.vue?vue&type=style&index=0&id=5062eea6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5062eea6",
  null
  
)

export default component.exports